import { render, staticRenderFns } from "./_categories.vue?vue&type=template&id=44408586&"
import script from "./_categories.vue?vue&type=script&lang=js&"
export * from "./_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports